import { UserOutlined } from "@ant-design/icons";
import {
  Avatar,
  Col,
  Form,
  Input,
  Row,
  DatePicker,
  Button,
  message,
  Upload,
} from "antd";
import React, { useEffect, useState } from "react";
import { AiFillEdit } from "react-icons/ai";
import { getUserById, updateUser } from "../../services/ApiService";
import { decryptObject, encryptObject } from "../GlobalFunction";

const EditProfile = ({ setUserData }) => {
  const [userDetails, setUserDetails] = useState({});
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [image, setImage] = useState(null);
  const [avatarUrl, setAvatarUrl] = useState(null);
  const sessionData = decryptObject(sessionStorage.getItem("sessioninfo"));

  const fetchDetail = async () => {
    try {
      setLoading(true);
      const res = await getUserById(sessionData.id);
      if (res.responseCode === 200) {
        setUserDetails(res.data);
        form.setFieldsValue(res.data);
        setAvatarUrl(res.data.picture || null);
      } else {
        message.error(res.message);
      }
    } catch (error) {
      message.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDetail();
  }, []);

  const handleImageChange = (file) => {
    setImage(file);
    setAvatarUrl(URL.createObjectURL(file));
  };

  const handleSubmit = async (values) => {
    const formData = new FormData();

    for (const key in values) {
      formData.append(key, values[key]);
    }

    if (image) {
      formData.append("employee_picture", image);
    } else if (avatarUrl) {
      formData.append("employee_picture", avatarUrl);
    }

    formData.append("user_id", sessionData.id);

    try {
      setLoading(true);
      const res = await updateUser(formData);
      if (res.responseCode === 200) {
        message.success("Profile updated successfully");
        sessionData.designation = values["designation"];
        const encrpt = encryptObject(sessionData);
        sessionStorage.setItem("sessioninfo", encrpt);
        if (setUserData) {
          setUserData({
            name: values["name"],
            designation: values["designation"],
          });
        }
        // window.location.reload();
      } else {
        message.error(res.message);
      }
    } catch (error) {
      message.error("Failed to update profile");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        padding: "1rem",
        height: "100%",
        display: "flex",
        gap: "2rem",
      }}
    >
      <span style={{ position: "relative", display: "inline-block" }}>
        <Avatar size={100} src={avatarUrl || <UserOutlined />} />
        <Upload
          beforeUpload={(file) => {
            handleImageChange(file);
            return false;
          }}
          showUploadList={false}
        >
          <Button
            type="primary"
            shape="circle"
            icon={<AiFillEdit />}
            style={{
              position: "absolute",
              top: "3rem",
              right: "1rem",
              transform: "translate(25%, 25%)",
            }}
          />
        </Upload>
      </span>

      <Form
        form={form}
        layout="vertical"
        style={{
          width: "100%",
          fontSize: "0.7rem",
        }}
        onFinish={handleSubmit}
      >
        <Row gutter={[16, 0]}>
          <Col xs={24} sm={24} md={12} lg={12}>
            <Form.Item label="Your Name" name="name" required>
              <Input placeholder="Enter your name" readOnly={true} />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12}>
            <Form.Item label="Employee Code" name="employee_id" required>
              <Input placeholder="Enter your employee code" readOnly={true} />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12}>
            <Form.Item label="Email" name="email_id" required>
              <Input
                type="email"
                placeholder="Enter your email"
                readOnly={true}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12}>
            <Form.Item label="Designation" name="designation" required>
              <Input type="text" placeholder="Enter your Designation" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={24} md={12} lg={12}>
            <Form.Item label="Date of Birth" name="dob" required>
              <DatePicker style={{ width: "100%" }} />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12}>
            <Form.Item label="Phone" name="phone" required>
              <Input type="tel" placeholder="Enter your phone number" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12}>
            <Form.Item label="Present Address" name="present_address" required>
              <Input placeholder="Enter your present address" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12}>
            <Form.Item
              label="Permanent Address"
              name="permanent_address"
              required
            >
              <Input placeholder="Enter your permanent address" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12}>
            <Form.Item label="City" name="city" required>
              <Input placeholder="Enter your city" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12}>
            <Form.Item label="Postal Code" name="postal_code" required>
              <Input placeholder="Enter your postal code" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12}>
            <Form.Item label="Country" name="country" required>
              <Input placeholder="Enter your country" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={24} lg={24}>
            <Button type="primary" htmlType="submit" loading={loading}>
              Update
            </Button>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default EditProfile;
